<template>
  <div class="w-full flex flex-col p-1 border-box h-full">
    <div class="h-12 w-full flex flex-none justify-center bg-white py-2 border-box border-t bg-gray-200">
      <pbc-toggle-button v-model='isChooseMode'>
        <h3 class="mx-3 my-1 font-semibold text-sm leading-snug tracking-wide">
          Gallery
        </h3>
      </pbc-toggle-button>
      <pbc-toggle-button v-model='isPackMode'>
        <h3 class="mx-3 my-1 font-semibold text-sm leading-snug tracking-wide">
          Pack
        </h3>
      </pbc-toggle-button>
      <pbc-toggle-button v-model='isUploadMode'>
        <h3 class="mx-3 my-1 font-semibold text-sm leading-snug tracking-wide">
          Upload
        </h3>
      </pbc-toggle-button>
    </div>

    <div class="grow overflow-auto">
      <apollo-image-gallery v-if='isChooseMode'
                            class="w-full shadow rounded"
                            :game-id='gameId'
                            @select='$emit("select", $event)'
                            />
      <choose-spritesheet v-if='isPackMode'
                            class="w-full shadow rounded"
                            @select='$emit("select", $event)'
                            />
      <image-uploader v-if='isUploadMode'
                            class="w-full shadow rounded"
                            :game-id='gameId'
                            @uploaded='onUpload'
                            :already-uploaded='uploadedImages'
                            @select='$emit("select", $event)'
                            />
    </div>
  </div>
</template>
<script>
import ImageUploader from '@ui/molecules/ImageUploader.vue';
import ApolloImageGallery from '@ui/organisms/ApolloImageGallery.vue';
import ChooseSpritesheet from '@ui/organisms/ChooseSpritesheet.vue';

export default {
  props: {
    gameId: {
      type: String,
      default: 'default'
    },
    uploadedImages: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      mode: 'choose'
    }
  },
  methods: {
    onUpload(image) {
      console.log('upload image', image);
      this.uploadedImages.push(image);
      this.$emit('uploadedImage', image);
    }
  },
  components: {
    ApolloImageGallery,
    ImageUploader,
    ChooseSpritesheet
  },
  computed: {
    isPackMode: {
      get() {
        return this.mode === "pack";
      },
      set(nv) {
        if (nv) {
          this.mode = "pack";
        }
      }
    },
    isChooseMode: {
      get() {
        return this.mode === "choose";
      },
      set(nv) {
        if (nv) {
          this.mode = "choose";
        }
      }
    },
    isUploadMode: {
      get() {
        return this.mode === "upload";
      },
      set(nv) {
        if (nv) {
          this.mode = "upload";
        }
      }
    }
  }
}
</script>
